module.exports = __webpack_public_path__ + "static/media/up-chevron.c26ca372.svg";